import(/* webpackMode: "eager" */ "/home/ec2-user/project-pulse/frontend/app/src/app/page.tsx");
